import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "hiddenInput", "status"]
  
  connect() {
    // Get meeting ID from the URL
    const pathParts = window.location.pathname.split('/')
    const meetingIndex = pathParts.indexOf('meetings')
    if (meetingIndex >= 0 && pathParts[meetingIndex + 1]) {
      this.meetingId = pathParts[meetingIndex + 1]
    }
  }
  
  selectProject(event) {
    const projectId = event.currentTarget.dataset.projectId
    this.updateProject(projectId)
    
    // Update the select dropdown to match
    if (this.hasSelectTarget) {
      this.selectTarget.value = projectId
    }
  }
  
  selectFromDropdown(event) {
    const projectId = event.target.value
    this.updateProject(projectId)
  }
  
  async updateProject(projectId) {
    if (!this.meetingId) return
    
    // Update hidden input
    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = projectId
    }
    
    // Show status
    this.showStatus("Saving...", "text-blue-600")
    
    try {
      const csrfToken = document.querySelector("[name='csrf-token']")?.content
      
      const response = await fetch(`/meetings/${this.meetingId}/assign_project`, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-CSRF-Token": csrfToken
        },
        body: JSON.stringify({ project_id: projectId })
      })
      
      const data = await response.json()
      
      if (data.success) {
        if (data.project_name) {
          this.showStatus(`Linked to "${data.project_name}"`, "text-green-600")
        } else {
          this.showStatus("Project removed", "text-slate-500")
        }
        
        // Reload page to update the UI fully after a short delay
        setTimeout(() => window.location.reload(), 1000)
      } else {
        this.showStatus(data.error || "Error saving", "text-red-600")
      }
    } catch (error) {
      console.error("Error assigning project:", error)
      this.showStatus("Error saving", "text-red-600")
    }
  }
  
  showStatus(message, colorClass) {
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = message
      this.statusTarget.className = `mt-2 text-xs ${colorClass}`
      this.statusTarget.classList.remove("hidden")
    }
  }
}

